import { BidsHeader } from '../models/bids-header';

export const publisherBidsHeaders: BidsHeader[] = [
  { SearchItem: 'BidDateTime', title: 'Bid Date', IsReversed: true, IsDefault: true, Size: 2 },
  { SearchItem: 'StateName', title: 'State', IsReversed: false, IsDefault: false, Size: 1 },
  { SearchItem: 'CountyName', title: 'County', IsReversed: false, IsDefault: false, Size: 2 },
  { SearchItem: 'ProjectTitle', title: 'Name', IsReversed: false, IsDefault: false, Size: 6 }
];
